export default function TestimonialSection() {
  return (
    <section className="py-16 md:py-20 px-6 md:px-10 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row gap-8 items-center">
          <div className="md:w-3/5">
            <div className="flex items-center gap-2 mb-6">
              <span className="w-2 h-2 rounded-full bg-accent-500"></span>
              <span className="text-xs font-label uppercase tracking-wider text-foreground-500">
                Verified User Review
              </span>
            </div>
            <blockquote className="text-2xl md:text-3xl lg:text-4xl font-heading font-medium text-foreground-900 leading-relaxed">
              &ldquo;Hipobuy Spreadsheet completely changed how I discover products. The organized categories save me hours every week.&rdquo;
            </blockquote>
            <div className="mt-6 flex items-center gap-3">
              <span className="text-sm font-semibold text-foreground-900">Marcus T.</span>
              <span className="flex items-center gap-1">
                <i className="ri-shield-check-line text-secondary-500 text-sm"></i>
                <span className="text-xs text-foreground-400">Verified User</span>
              </span>
            </div>
          </div>
          <div className="md:w-2/5">
            <img
              src="https://readdy.ai/api/search-image?query=Elegant%20editorial%20portrait%20of%20confident%20young%20woman%20with%20stylish%20messy%20bun%20hairstyle%20wearing%20bright%20coral%20blouse%20against%20clean%20white%20studio%20background%2C%20warm%20natural%20lighting%20from%20window%2C%20modern%20fashion%20portrait%20photography%2C%20fresh%20vibrant%20color%20palette%2C%20approachable%20genuine%20expression%2C%20professional%20yet%20friendly%20aesthetic%2C%20shoulder%20up%20composition&width=600&height=800&seq=testimonial-portrait-v2&orientation=portrait"
              alt="Verified Hipobuy Spreadsheet user testimonial"
              className="w-full h-72 md:h-96 object-cover object-top rounded-lg"
            />
          </div>
        </div>
      </div>
    </section>
  );
}